import React from 'react'
import { ContactInfoChangeStepsContextProvider } from '../../context/ContactInfoChangeContext'
import { ContactInfoChangeStepRoutes } from '../../routes/ContactInfoChange/ContactInfoChange'

export default function ContactInfoChangeWithStepsContext() {
  return (
    <ContactInfoChangeStepsContextProvider>
      <ContactInfoChangeStepRoutes />
    </ContactInfoChangeStepsContextProvider>
  )
}
